import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { LinkProps } from '../../containers/Link/types';

const Link = ({ children, className }: LinkProps): ReactElement => {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a href="#" className={className}>
      {children}
    </a>
  );
};

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #cf1b53;
  &:hover {
  }
`;

export const FakeLink = ({
  to,
  children,
  className,
}: LinkProps): ReactElement => {
  return (
    <StyledLink className={className} to={to}>
      {children}
    </StyledLink>
  );
};
